function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#dde0e5}.cls-4{fill:#4d4d4f}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2437",
  transform: "translate(-1047 -443)"
}, /*#__PURE__*/React.createElement("path", {
  id: "_457a5d8a63427931dc01f75cb14de5d9",
  fill: "#fff",
  d: "M.8 0h58.4a.949.949 0 0 1 .8 1.048v57.9A.949.949 0 0 1 59.2 60H.8a.949.949 0 0 1-.8-1.048V1.048A.949.949 0 0 1 .8 0z",
  transform: "translate(1047 443)"
}), /*#__PURE__*/React.createElement("g", {
  id: "power-plant",
  transform: "translate(1057 453)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1125",
  d: "M9.318-3.861A1.244 1.244 0 0 0 8.072-5H3.9a1.241 1.241 0 0 0-1.24 1.139L1.022 22.728a1.223 1.223 0 0 0 .437 1.035 1.264 1.264 0 0 0 .81.293l.3-.035 7.307-1.758a1.236 1.236 0 0 0 .95-1.294z",
  className: "cls-2",
  transform: "translate(0.678 6.111)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1126",
  fill: "#b7c0c9",
  d: "M15.367 11.773a1.259 1.259 0 0 0-1.05-.244l-12.023 2.6A2.9 2.9 0 0 0 0 16.94v6.082A2.9 2.9 0 0 0 2.917 25.9h11.666a1.243 1.243 0 0 0 1.25-1.235V12.734a1.227 1.227 0 0 0-.466-.961z",
  transform: "translate(0 14.097)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1127",
  d: "M7.333 18.219H4a1.235 1.235 0 1 1 0-2.469h3.333a1.235 1.235 0 1 1 0 2.469z",
  className: "cls-4",
  transform: "translate(1.833 16.843)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1128",
  d: "M9.75 2.469h-7.5A1.243 1.243 0 0 1 1 1.235 1.243 1.243 0 0 1 2.25 0h7.5A1.243 1.243 0 0 1 11 1.235a1.243 1.243 0 0 1-1.25 1.234z",
  className: "cls-4",
  transform: "translate(0.667)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1129",
  d: "M33.67 11.214L9.5 6.276a1.258 1.258 0 0 0-1.042.252A1.225 1.225 0 0 0 8 7.484v20.577A1.243 1.243 0 0 0 9.25 29.3h22.5a2.9 2.9 0 0 0 2.917-2.881V12.423a1.237 1.237 0 0 0-.997-1.209z",
  className: "cls-2",
  transform: "translate(5.333 10.705)"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_2733",
  transform: "translate(18.333 25.185)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1134",
  d: "M13.083 14.542h-.833A1.243 1.243 0 0 1 11 13.308v-.823a1.243 1.243 0 0 1 1.25-1.235h.833a1.243 1.243 0 0 1 1.25 1.235v.823a1.243 1.243 0 0 1-1.25 1.234z",
  className: "cls-4",
  transform: "translate(-11 -11.25)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1135",
  d: "M17.083 14.542h-.833A1.243 1.243 0 0 1 15 13.308v-.823a1.243 1.243 0 0 1 1.25-1.235h.833a1.243 1.243 0 0 1 1.25 1.235v.823a1.243 1.243 0 0 1-1.25 1.234z",
  className: "cls-4",
  transform: "translate(-8.333 -11.25)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1136",
  d: "M21.083 14.542h-.833A1.243 1.243 0 0 1 19 13.308v-.823a1.243 1.243 0 0 1 1.25-1.235h.833a1.243 1.243 0 0 1 1.25 1.235v.823a1.243 1.243 0 0 1-1.25 1.234z",
  className: "cls-4",
  transform: "translate(-5.667 -11.25)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1137",
  d: "M13.083 18.542h-.833A1.243 1.243 0 0 1 11 17.308v-.823a1.243 1.243 0 0 1 1.25-1.235h.833a1.243 1.243 0 0 1 1.25 1.235v.823a1.243 1.243 0 0 1-1.25 1.234z",
  className: "cls-4",
  transform: "translate(-11 -8.666)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1138",
  d: "M17.083 18.542h-.833A1.243 1.243 0 0 1 15 17.308v-.823a1.243 1.243 0 0 1 1.25-1.235h.833a1.243 1.243 0 0 1 1.25 1.235v.823a1.243 1.243 0 0 1-1.25 1.234z",
  className: "cls-4",
  transform: "translate(-8.333 -8.666)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1139",
  d: "M21.083 18.542h-.833A1.243 1.243 0 0 1 19 17.308v-.823a1.243 1.243 0 0 1 1.25-1.235h.833a1.243 1.243 0 0 1 1.25 1.235v.823a1.243 1.243 0 0 1-1.25 1.234z",
  className: "cls-4",
  transform: "translate(-5.667 -8.666)"
}))));

function SvgGreyIconManufacturer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyIconManufacturer);
export default __webpack_public_path__ + "static/media/greyIconManufacturer.0edc2305.svg";
export { ForwardRef as ReactComponent };